import { useEffect } from 'react';

/**
 * The static tags in index.html and the route-specific tags rendered by
 * react-helmet-async both ship in the head, so a crawler that runs JavaScript
 * sees two descriptions/titles per page and has to guess which one describes
 * the page. Once a route has supplied its own value, drop the static fallback
 * so exactly one of each survives. Crawlers that do not run JavaScript still
 * read the static tags straight from index.html, unchanged.
 */
const SELECTORS = [
  'meta[name="description"]',
  'meta[property="og:description"]',
  'meta[name="twitter:description"]',
  'meta[property="og:title"]',
  'meta[name="twitter:title"]',
  'meta[property="og:url"]',
];

function dedupeHead() {
  for (const selector of SELECTORS) {
    const tags = Array.from(document.head.querySelectorAll(selector));
    // Tags react-helmet-async injected are the route-specific ones.
    const managed = tags.filter((tag) => tag.hasAttribute('data-rh'));
    if (managed.length === 0) continue;
    const keep = managed[managed.length - 1];
    for (const tag of tags) {
      if (tag !== keep) tag.remove();
    }
  }
}

export default function HeadDedupe() {
  useEffect(() => {
    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        dedupeHead();
      });
    };

    const observer = new MutationObserver(schedule);
    observer.observe(document.head, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['content'],
    });
    schedule();

    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return null;
}
